import React from "react";
import { BrowserRouter as Router, useLocation, useNavigate } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { useTheme } from "./context/ThemeContext";
import ThemeSelector from "./components/ThemeSelector";
import { GuestProvider } from "./context/GuestContext";
import { Toaster } from "react-hot-toast";

const AppWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();

  // Splash page
  React.useEffect(() => {
    if (location.pathname === "/") {
      navigate("/splash");
    }
  }, [location.pathname, navigate]);

  return (
    <div className={`min-h-screen bg-gradient-to-r ${theme} relative`}>
      <Toaster position="top-right" reverseOrder={false} />
      
      {/* Theme Selector on all pages */}
      <ThemeSelector currentTheme={theme} setTheme={setTheme} />

      <AppRoutes />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <GuestProvider>
        <AppWrapper />
      </GuestProvider>
    </Router>
  );
};

export default App;
